/**
 * Factory to generate store modules
 */

import { Module, ActionTree, MutationTree, ModuleTree, GetterTree } from 'vuex'
import { cloneDeep } from 'lodash'
import { IRootState } from '@/services/store/store.types'
import { make } from 'vuex-pathify'
import { IStoreFactoryOptions } from '@/types'

/**
 * @param S type of State
 */
export default class StoreFactory<S> {
  public state: S
  public actions: ActionTree<S, IRootState>
  public mutations: MutationTree<S>
  public getters: GetterTree<S, IRootState>
  public modules: ModuleTree<IRootState>

  constructor(factoryOptions: IStoreFactoryOptions<S>) {
    this.state = {
      // @ts-ignore
      ...cloneDeep(factoryOptions.state),
    }
    this.actions = {
      ...make.actions(this.state),
      ...factoryOptions.actions,

      resetState(context) {
        context.commit('RESET_STATE')
      },
    }

    this.mutations = {
      ...make.mutations(this.state),
      ...factoryOptions.mutations,

      RESET_STATE(state) {
        const initialState = cloneDeep(factoryOptions.state)
        Object.keys(state).forEach(property => {
          // @ts-ignore
          state[property] = initialState[property]
        })
      },
    }
    this.getters = factoryOptions.getters
    this.modules = factoryOptions.modules
  }

  public storeOptions(): Module<S, IRootState> {
    return {
      namespaced: true,
      state: this.state,
      actions: this.actions,
      mutations: this.mutations,
      modules: this.modules,
    }
  }
}
